// import React from 'react'
// import {
//   Box,
//   Container,
//   Typography,
//   Divider,
//   CardMedia,
//   Paper,
// } from "@mui/material";

// function ArticlePage() {
//   const article={
//     title: "Boosting Renewable Energy Access in Jamaica",
//     img: "https://picsum.photos/300/200?random=10",
//     url:"/articles/Boosting Renewable Energy Access in Jamaica",
//     id:1,
//     category:"Health",
//     subcategory:"maternal health",
//     project:"Conducting prenatal health emergencies in Lake Victoria Islands",
//     content:[
//       {type:"text",value:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",heading:"What is Lorem Ipsum?"},
//       {type:"text",value:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",heading:"Why do we use it?"},
//       {type:"image",value:"https://picsum.photos/300/200?random=7",heading:"Why do we use it?"},
//       {type:"text",value:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also",heading:"Where does it come from?"},
//       {type:"video",value:"https://picsum.photos/300/200?random=9",heading:""},
//     ],
//     comments:[]
//   }
//   return (
//     <Container maxWidth="md" sx={{ my: 5 ,mt:20}}>
//       {/* Hero Section */}
//       <Box sx={{ textAlign: "center", mb: 4 }}>
//         <Typography
//           variant="h3"
//           fontWeight={700}
//           gutterBottom
//           sx={{ fontFamily: "Merriweather, serif" }}
//         >
//           {article.title}
//         </Typography>
//         <Typography
//           variant="subtitle1"
//           color="text.secondary"
//           sx={{ fontStyle: "italic" }}
//         >
//           {article.category} • {article.project}
//         </Typography>

//         <CardMedia
//           component="img"
//           image={article.img}
//           alt={article.title}
//           sx={{
//             borderRadius: 2,
//             height: { xs: 200, md: 400 },
//             objectFit: "cover",
//             my: 3,
//           }}
//         />
//       </Box>

//       <Divider sx={{ mb: 4 }} />

//       {/* Article Body */}
//       <Box>
//         {article.content.map((section, index) => (
//           <Box key={index} sx={{ mb: 5 }}>
//             {section.heading && (
//               <Typography
//                 variant="h5"
//                 fontWeight={700}
//                 gutterBottom
//                 sx={{
//                   mt: 3,
//                   fontFamily: "Merriweather, serif",
//                   borderLeft: "4px solid #1976d2",
//                   pl: 1.5,
//                 }}
//               >
//                 {section.heading}
//               </Typography>
//             )}

//             {section.type === "text" && (
//               <Typography
//                 variant="body1"
//                 sx={{
//                   lineHeight: 1.8,
//                   color: "text.primary",
//                   whiteSpace: "pre-line",
//                   textAlign: "justify",
//                   fontSize: "1.05rem",
//                   mt: section.heading ? 1 : 0,
//                 }}
//               >
//                 {section.value}
//               </Typography>
//             )}

//             {section.type === "image" && (
//               <Paper
//                 elevation={2}
//                 sx={{
//                   my: 3,
//                   borderRadius: 2,
//                   overflow: "hidden",
//                   textAlign: "center",
//                 }}
//               >
//                 <img
//                   src={section.value}
//                   alt={section.heading || "Article image"}
//                   style={{
//                     width: "100%",
//                     height: "auto",
//                     display: "block",
//                     maxHeight: "500px",
//                     objectFit: "cover",
//                   }}
//                 />
//                 {section.heading && (
//                   <Typography
//                     variant="caption"
//                     color="text.secondary"
//                     sx={{ display: "block", py: 1 }}
//                   >
//                     {section.heading}
//                   </Typography>
//                 )}
//               </Paper>
//             )}

//             {section.type === "video" && (
//               <Box
//                 sx={{
//                   my: 3,
//                   borderRadius: 2,
//                   overflow: "hidden",
//                   position: "relative",
//                   aspectRatio: "16/9",
//                 }}
//               >
//                 <iframe
//                   width="100%"
//                   height="100%"
//                   src={section.value}
//                   title={section.heading || "Article video"}
//                   frameBorder="0"
//                   allowFullScreen
//                 ></iframe>
//               </Box>
//             )}
//           </Box>
//         ))}
//       </Box>
//     </Container>
//   );
// };


// export default ArticlePage

import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Container,
  Typography,
  Divider,
  CardMedia,
  Avatar,
  Chip,
  Paper,
  Link,
  Button,
  Stack,
  IconButton,
  TextField,
  MenuItem
} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import { useLocation } from "react-router";
import AddSectionForm from "../forms/AddSectionForm";
import useApi from "../../api/useApi";
import { ArticleGetBatch, ArticleGetDetail, ArticlePut, CampaignGetDetail, CampaignUpdate } from "../../api/orgService";
import { toast } from "react-toastify";
import { Edit as EditIcon, Save as SaveIcon, Close as CloseIcon } from "@mui/icons-material";
import CampaignShowcase from "../sections/CampaignShowcase";




const CampaignPublicReadPage = ({campaignData,articleData,isCampaign}) => {
  const [isEditing,setIsEdit]=useState(false)
  const [titleEdit, setTitleEdit] = useState(false);
  const [file_upload_state, setConstFileUpload]=useState(false)
  const [article,setArticle] = useState({
    title: "Boosting Renewable Energy Access in Jamaica",
    img: "https://fountainafrica.org/wp-content/uploads/2020/01/Her-Excellency-The-first-Lady-Margaret-Kenyatta-Visit-Birth-Wise-Stand-in-Beyond-Zero-Campaign-launch-in-Bungoma-County-1-768x420.jpg",
    url: "/articles/Boosting-Renewable-Energy-Access-in-Jamaica",
    id: 1,
    category: "Health",
    subcategory: "Maternal health",
    project: "Conducting prenatal health emergencies in Lake Victoria Islands",
    publisher: {
      name: "Palash K Das",
      logo: "https://i.pravatar.cc/100?img=5",
      url: "https://www.dhakatribune.com/",
      date: "October 14, 2025",
    },
    tags: ["Energy", "Climate", "Sustainability", "Poverty Reduction"],
    related: [
      {
        title: "The looming threat of persistent inequality",
        img: "https://picsum.photos/200/100?random=1",
        url: "/articles/The looming threat of persistent inequality",
      },
      {
        title: "Adapting to climate change with innovation",
        img: "https://picsum.photos/200/100?random=2",
        url: "/articles/climate-change-innovation",
      },
    ],
    content: [
      {
        type: "text",
        heading: "What is Lorem Ipsum?",
        value:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry...",
      },
      // {type:"text",value:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",heading:"What is Lorem Ipsum?"},
      // {type:"text",value:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",heading:"Why do we use it?"},
      // {type:"image",value:"https://picsum.photos/300/200?random=7",heading:"Why do we use it?"},
      // {type:"text",value:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also",heading:"Where does it come from?"},
      {
        type: "image",
        value: "https://picsum.photos/800/400?random=7",
        heading: "Why do we use it?",
      },
      {
        type: "text",
        heading: "Where does it come from?",
        value:
          "Contrary to popular belief, Lorem Ipsum is not simply random text...",
      },
      {
        type: "video",
        value: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      },
    ],
  })

  const [tempTitle, setTempTitle] = useState(article?.title);
  const location = useLocation()
  const [mainArticleImagePreview,setMainArticleImagePreview]=useState(null)
  const [campaign,setCampaign] = useState({})
  const [relatedArticles,setRelatedArticles]=useState([])

  // ---------------------------publish Logic --------------------------------

  const { request: updateArticle, data:articleUpdateData, error:articleUpdateError} = useApi(ArticlePut);
  const { request: getCampaign, data:campaignGetData, error:campaignGetError} = useApi(CampaignGetDetail);
//   const { request: getArticleDetail, data:getArticleDetailData, error:getArticleDetailError} = useApi(ArticleGetDetail);
   const { request: getRelatedArticles, data:relatedArticlesData, error:relatedArticlesError,isLoading:getRelatedArticlesLoading} = useApi(ArticleGetBatch);

  useEffect(()=>{
    if(location?.state?.campaign){
        getCampaign(location?.state?.campaign?.id)
    }else if(location?.state === null){
        // console.log(location?.pathname.split("/"))
        if(location?.pathname?.includes("/campaign/campaigndetail/")){
            console.log("check: ",location?.pathname.split("/")[3])
        getCampaign(location?.pathname.split("/")[3])
        }
    }else if(location?.pathname?.includes("/campaign/campaigndetail/")){
        console.log("check: ",location?.pathname.split("/")[3])
    getCampaign(location?.pathname.split("/")[3])
    }
},[location?.pathname,location?.state])

  useEffect(()=>{
    if (campaignData) {
        setCampaign(campaignData);
        setArticle(campaignData?.content);
    //   setTempTitle(articleData?.title)
    }
  },[campaignData,location])

  useEffect(()=>{
    if(isCampaign === true){
    console.log("showing campaign detail")
    }
  },[isCampaign])


  
  
  
    useEffect(()=>{
      if (campaignGetData?.status===200) {
        setCampaign(campaignGetData?.data);
      }
    },[campaignGetData])


    useEffect(() => {
    if(campaign?.sub_category?.id){
        // console.log("project: ",project)
    getRelatedArticles({subcategory:campaign?.sub_category?.id});
    }
            // eslint-disable-next-line
    }, [campaign]);
            
    useEffect(()=>{
        if (relatedArticlesData?.status===200) {
        setRelatedArticles(relatedArticlesData?.data?.results);
        }
    // eslint-disable-next-line
    },[relatedArticlesData])
    

    useEffect(()=>{
        if(campaignGetError){
            toast.error(`${JSON.stringify(campaignGetError?.response?.data,null,2)}`,{position: "top-center"});
      }
    },[campaignGetError])

  // -------------------------end publish logic -------------------------------

  const fileInputRef = useRef(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file){
    const previewUrl = URL.createObjectURL(file);
    // setArticle((prev) => ({ ...prev, img: previewUrl }));
    setMainArticleImagePreview({file:file,previewUrl:previewUrl})


    const formData = new FormData();
    formData.append("image", file);
    setConstFileUpload(true)
    try{
      const res = await fetch("https://fountainafrica.org/cms/ftp-files/", {
        method: "POST",
        body: formData, // don't add headers here
      });
    // console.log(res)
    if(res?.status===201){
      let result = await res.json()
      console.log("Upload urls: ",result)
      setMainArticleImagePreview((prev) => ({ ...prev, previewUrl: result?.path }));
      setCampaign((prevData)=>({
        ...prevData,
        media: result?.path,
      }));
    // setMaterialUrl(event,event.target.value)
      // setUploadUrls(prev=>res?.data)
      setConstFileUpload(false)
    }else{
      console.log(res)
    }
    }catch(error){
      console.log(error)
    }
    }
  };

  const handleChange = (e) => {
    // setForm({ ...form, [e.target.name]: e.target.value });
    setCampaign(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSaveDraft = () => {
    try {
      localStorage.setItem("articleDraft", JSON.stringify(article));
      alert("✅ Draft saved successfully!");
    } catch (error) {
      console.error("Error saving draft:", error);
      alert("⚠️ Failed to save draft.");
    }
  };

  const onAddSection = (newSection)=>{
    setCampaign(prev => ({
      ...prev, // keep everything else in the article
      content: [...(prev.content || []), newSection] // add the new section at the end
    }));
  }

  const handleEditTitleClick = () => {
    setTitleEdit(true)
  };

  const handleEdit = () => {
    if(isEditing){
      setIsEdit(!isEditing)
      alert("📝 Edit mode deactivated");
    }else{
      setIsEdit(!isEditing)
      alert("📝 Edit mode activated (placeholder)");
    }
  };
  const handleViewOriginal = () => {
    alert("👁️ Viewing original version (placeholder)");
  };


  // Load draft if available
  const handleLoadDraft = () => {
    const saved = localStorage.getItem("articleDraft");
    if (saved) {
      setArticle(JSON.parse(saved));
      alert("✅ Draft loaded successfully!");
    } else {
      alert("⚠️ No draft found in local storage.");
    }
  };

  const handleSaveTitle = ()=>{
    setArticle(prev => ({
      ...prev, // keep everything else in the article
       title: tempTitle ,// add the new title
    }));
    setTitleEdit(false)
  }

  const handleCancelTitle = ()=>{
    setTitleEdit(false)
  }

  

  return (
    <Container 
    sx={{
      width: "80%",       // 80% of viewport or parent
      maxWidth: "100%",   // prevent MUI's default maxWidth
      mx: "auto",         // center horizontally
      my: 5,
    }}
    >
      <Grid container spacing={4} sx={{width: "100%"}}>
        {/* Main Content */}
        <Grid item xs={12} md={8} sx={{ overflowY: 'auto',width: "100%" }}>
          

          {/* Hero Section */}
          <Box sx={{ textAlign: "center", mb: 4 }}>
            {<Stack direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{ width: "100%" }}>
              <Typography
              variant="h3"
              fontWeight={700}
              gutterBottom
              sx={{ 
                fontFamily: "Merriweather, serif",
                wordWrap: 'break-word',
                overflowWrap: "break-word",
                whiteSpace: "normal",
                overflow: "hidden",
              }}
            >
              {campaign?.name}
            </Typography>
            </Stack>
            }

            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
             Fountain Africa In {campaign?.category?.name||campaign?.category}
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
             {campaign?.sub_category?.name||campaign?.sub_category} • {campaign?.project?.description || campaign?.project?.name||campaign?.project}
            </Typography>

            <CampaignShowcase 
            campaign={campaign}
            isPublicReadDetail={true} 
            />

          </Box>

          {/* Publisher Info */}
          {campaign?.publisher && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 3,
                gap: 2,
              }}
            >
              <Avatar
                alt={article.publisher.name}
                src={article.publisher?.logo}
                sx={{ width: 48, height: 48 }}
              />
              <Box>
                <Typography fontWeight={600}>
                  <Link
                    href={article.publisher?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    color="inherit"
                  >
                    {`${article.publisher?.staff_user?.first_name} ${article.publisher?.staff_user?.last_name}`||article.publisher.name}
                  </Link>
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Published on {article?.created_at || "N/A"}
                </Typography>
              </Box>
            </Box>
          )}

          <Divider sx={{ mb: 4 }} />

          {/* Article Body */}
          <Box>
            {campaign?.content?.map((section, index) => (
              <Box key={index} sx={{ mb: 5}}>
                {section.heading && (
                  <Typography
                    variant="h5"
                    fontWeight={700}
                    gutterBottom
                    sx={{
                      mt: 3,
                      fontFamily: "Merriweather, serif",
                      borderLeft: "4px solid #1976d2",
                      pl: 1.5,
                    }}
                  >
                    {section.heading}
                  </Typography>
                )}

                {section.type === "text" && (
                  <Typography
                    variant="body1"
                    sx={{
                      lineHeight: 1.8,
                      color: "text.primary",
                      whiteSpace: "pre-line",
                      textAlign: "justify",
                      fontSize: "1.05rem",
                      mt: section.heading ? 1 : 0,
                    }}
                  >
                    {section.value}
                  </Typography>
                )}

                {section.type === "image" && (
                  <Paper
                    elevation={2}
                    sx={{
                      my: 3,
                      borderRadius: 2,
                      overflow: "hidden",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={section.value}
                      alt={section.heading || "Article image"}
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        maxHeight: "500px",
                        objectFit: "cover",
                      }}
                    />
                    {section.heading && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block", py: 1 }}
                      >
                        {section.heading}
                      </Typography>
                    )}
                  </Paper>
                )}

                {section.type === "video" && (
                  <Box
                    sx={{
                      my: 3,
                      borderRadius: 2,
                      overflow: "hidden",
                      position: "relative",
                      aspectRatio: "16/9",
                    }}
                  >
                    <iframe
                      width="100%"
                      height="100%"
                      src={section.value}
                      title={section.heading || "Article video"}
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Sidebar */}
        <Grid item xs={12} md={4}>
          <Box sx={{ position: { md: "sticky" }, top: 100 }}>
            {/* Tags */}
            {article?.tags && (
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h6"
                  fontWeight={600}
                  gutterBottom
                  sx={{ fontFamily: "Merriweather, serif" }}
                >
                  Tags
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {article.tags.map((tag, i) => (
                    <Chip key={i} label={tag} variant="outlined" />
                  ))}
                </Box>
              </Box>
            )}

            {/* Related Articles */}
            {article?.related && (
              <Box>
                 {/* Save Draft Button */}
              
                <Typography
                  variant="h6"
                  fontWeight={600}
                  gutterBottom
                  sx={{ fontFamily: "Merriweather, serif" }}
                >
                  Related Articles
                </Typography>
                {article.related.map((item, i) => (
                  <Box key={i} sx={{ mb: 2 }}>
                    <Box
                      // href={item.url}
                      component="a" 
                      href={item?.url}
                      underline="none"
                      color="inherit"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        "&:hover .thumb": { transform: "scale(1.05)" },
                      }}
                    >
                      <img
                        src={item.img}
                        alt={item.title}
                        className="thumb"
                        style={{
                          width: 80,
                          height: 60,
                          objectFit: "cover",
                          borderRadius: 6,
                          transition: "transform 0.3s ease",
                        }}
                      />
                      <Typography variant="body2" fontWeight={500}>
                        {item.title}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CampaignPublicReadPage;